import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { PlayerContentItem, StationManagerService } from '@splixer/player';
import * as dayjs from 'dayjs';
import { SlicePipe } from '@angular/common';

/**
 * Displays the track info - name, artist, album, release date, label
 * Does NOT display album artwork.
 * If you don't want the startedAt date to display, don't pass it!
 */
@Component({
  selector: 'pv3-track-info',
  templateUrl: 'track-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SlicePipe],
})
export class Pv3TrackInfoComponent {
  public content = input.required<PlayerContentItem>();
  public startedAt = input<dayjs.Dayjs | undefined>();
  public showAlbumArt = input(false, { transform: booleanAttribute });
  public showPlayTime = input(true, { transform: booleanAttribute });

  protected station = inject(StationManagerService);

  protected startedAtFormatted = computed(() => {
    let d: string | undefined;
    const sa = this.startedAt();
    if (sa) {
      d = this.station.formatTime(sa);
    }
    return d;
  });

  protected albumArtUrl = computed(() => {
    const c = this.content();
    let url: string | undefined;
    if (c.coverArtUrl) {
      url = c.coverArtUrl;
    } else {
      url = this.station.defaultAlbumArtThumbnailUrl;
    }
    return url;
  });
}
